import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface InvitedByTabProps {
  isFeaturedEvent?: boolean;
  name: string;
}
export const InvitedByTab = ({
  name,
  isFeaturedEvent = false,
}: InvitedByTabProps) => {
  const displayName = name || t("events.rsvp.host");

  return (
    <div
      className={classNames(
        "mb-5 flex h-[44px] w-full items-center justify-start gap-x-3 border border-green-200 bg-green-50",
        isFeaturedEvent ? "rounded-t-xl sm:rounded-xl" : "rounded-xl",
      )}
    >
      <Icon type="20-users-plus" size={20} className="ms-3" />
      <Typography.LabelXs weight="medium" color="text-[#18181B]">
        {t("events.rsvp.invited_by", { name: displayName })}
      </Typography.LabelXs>
    </div>
  );
};
